import { useState, useCallback } from "react";

export function useExploreReviewState() {
  const [expandedReviews, setExpandedReviews] = useState<Set<number>>(
    new Set()
  );
  const [imageLoaded, setImageLoaded] = useState<Record<number, boolean>>({});

  const toggleReview = useCallback((reviewId: number) => {
    setExpandedReviews((prev) => {
      const next = new Set(prev);
      if (next.has(reviewId)) next.delete(reviewId);
      else next.add(reviewId);
      return next;
    });
  }, []);

  const handleImageLoad = useCallback((reviewId: number) => {
    setImageLoaded((prev) => ({ ...prev, [reviewId]: true }));
  }, []);

  return {
    expandedReviews,
    imageLoaded,
    toggleReview,
    handleImageLoad,
  };
}
